export default "__VITE_ASSET__Dy5eC6ed__"